import { createSelector } from '@reduxjs/toolkit';

export const selectHomeSlice = (state) => state.home;

export const selectUser = createSelector([selectHomeSlice], (homeSlice) => homeSlice.user);
export const selectRoles = createSelector([selectHomeSlice], (homeSlice) => homeSlice.allRoles);
export const selectSelectedRole = createSelector([selectHomeSlice], (homeSlice) => homeSlice.selectedRole);
export const selectApps = createSelector([selectHomeSlice], (homeSlice) => homeSlice.allApps);
